import type { ComponentProps } from "react"
import { Toaster as Sonner } from "sonner"

type ToasterProps = ComponentProps<typeof Sonner>

/**
 * App-wide toast surface (shadcn-style wrapper around sonner). Mounted once at
 * the app root; feature code fires toasts via the `toast` helper in
 * `@/lib/toast`. Light theme + richColors so success/error read distinctly
 * against the VONK background. Top-right since spec-65 (U-029): bottom-right is
 * where the Sparky button lives.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      position="top-right"
      richColors
      closeButton
      {...props}
    />
  )
}

export { Toaster }
